import Header from "../../components/Header";
import Content from "../../components/Content";
import WaveFooter from "../../components/WaveFooter";

export default function Home() {
    return (
      <>
        <Header />
        <Content />
        <WaveFooter />
      </>
    );
  }